import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { config } from '@config/config';
import { DataComponent } from '@app/utils/data.component';
import { NotificationService } from '@app/models/notifications/notifications.service';
import { trackEvent } from '@app/utils/amplitude.utils';
var NotificationsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsComponent, _super);
    function NotificationsComponent(notifs, dialogService, router) {
        var _this = _super.call(this) || this;
        _this.notifs = notifs;
        _this.dialogService = dialogService;
        _this.router = router;
        _this.entitlement = null;
        _this.markedRead = new EventEmitter();
        _this.clearRead = new EventEmitter();
        _this.hidePopover = new EventEmitter();
        _this.notifTypes = config.notificationTypes;
        _this.notifTypeFormat = config.notificationTypeFormat;
        _this.gaugeData = {};
        _this.notifications = [];
        _this.loading = true;
        return _this;
    }
    NotificationsComponent.prototype.onInit = function () {
        var _this = this;
        /*
         * this subscription is observing the notification service
         * the notification service calls the notification data from the header component when the header loads
         * this makes the notification data ready before the notification panel is opened
         */
        this.notifs.unreadNotifications.subscribe(function (unreadNotifications) {
            _this.unreadNotifications = unreadNotifications;
        });
        trackEvent('Notifications Viewed');
    };
    NotificationsComponent.prototype.setRead = function (model, read) {
        this.notifs.setRead(model.id, read).subscribe(function () { return (model.read = read); });
        this.markedRead.emit();
    };
    NotificationsComponent.prototype.viewAllNotifications = function () {
        this.hidePopover.emit();
        this.router.navigate(['/notifications']);
    };
    return NotificationsComponent;
}(DataComponent));
export { NotificationsComponent };
